import { render, staticRenderFns } from "./MFAInput.vue?vue&type=template&id=628d390c"
import script from "./MFAInput.vue?vue&type=script&lang=js"
export * from "./MFAInput.vue?vue&type=script&lang=js"
import style0 from "./MFAInput.vue?vue&type=style&index=0&id=628d390c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports